import styled, { css } from 'styled-components'

const StyledEditabledSelectContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  ${props =>
    props.isDisabled &&
    css`
      cursor: not-allowed;
    `};
`

export default StyledEditabledSelectContainer
